/**
 * Indica que el datepicker generará un string como valor final para formik
 */
export const PRODUCE_STRING = 'string';

/**
 * Indica que el datepicker generará un objeto Date como valor final para formik
 */
export const PRODUCE_DATE = 'date';

/**
 * Indica el formato por defecto para los datepicker
 */
export const DP_DEFAULT_FORMAT = 'YYYY-MM-DD';

/**
 * Indica el formato por defecto para los datetimepicker
 */
export const DTP_DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm';

export const DTP_ISO8601_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const YEAR_FORMAT = 'YYYY';
export const YEAR_MONTH_FORMAT = 'YYYY-MM';

/**
 * Indica el formato por defecto para los timepicker
 */
export const TP_DEFAULT_FORMAT = 'HH:mm:ss';
export const TP_NO_SECONDS_FORMAT = 'HH:mm';
